import { getElement } from "./utils";

export const lighboxImages = () => {

  // Create lightbox div in the body
  const lightbox = document.createElement('div');
  lightbox.className = 'lightbox-bg';
  document.body.appendChild(lightbox);

  const imgContainer = document.createElement('img');
  imgContainer.className = 'lightbox-content';
  lightbox.appendChild(imgContainer);

  // Function to open the lightbox
  const images = document.querySelectorAll('.wp-block-image img, .testimonials-archive img');
  if (images != undefined && images != null) {

    images.forEach(image => {
      image.addEventListener('click', () => {
        lightbox.style.display = 'flex';
        imgContainer.src = image.src;
      });
    });

    // Click on the lightbox to close it
    lightbox.addEventListener('click', () => {
      lightbox.style.display = 'none';
    });

  }

}